import { isEqual } from 'lodash';

export type PropsAreEqualProps = {
  prevProps: any,
  nextProps: any
};

/**
 * @param {*} prevProps
 * @param {*} nextProps
 * @return {boolean}
 */
export function propsAreEqual(prevProps:any, nextProps:any):boolean {
  return isEqual(prevProps, nextProps);
}